export class PromotoraDadosGestaoDTO {
  public id!: number;
  public idPromotora!: number;
  public sociosJson!: string;
  public diretoresJson!: string;
  public testemunhasJson!: string;
  public atuacaoGeografica!: string;
  public quantidadePostosAtendimento!: string;
  public descricaoPostosAtendimento!: string;
  public conveniosAtivosJson!: string;
  public parceirosJson!: string;
  public tempoOperacao!: string;
  public produtoConsignadoPublico!: boolean;
  public produtoConsignadoPrivado!: boolean;
  public produtoInss!: boolean;
  public produtoEmprestimoPessoal!: boolean;
  public nomeBanco!: string;
  public numeroBanco!: string;
  public numeroAgencia!: string;
  public contaCorrente!: string;
  public nomeUsuarioCadastro!: string;
  public dtInclusao!: Date;
}
